var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCopy, faDownload, faLink, faShareAlt, faTrashRestore } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { copyWorkflow, undeleteWorkflow } from "@/components/Workflow/workflows.services";
import { useConfirmDialog } from "@/composables/confirmDialog";
import { Toast } from "@/composables/toast";
import { useUserStore } from "@/stores/userStore";
import { copy } from "@/utils/clipboard";
import { withPrefix } from "@/utils/redirect";
import { getFullAppUrl } from "@/utils/utils";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowActionsExtend',
    props: {
        workflow: null,
        menu: { type: Boolean },
        published: { type: Boolean },
        buttonSize: { default: "sm" }
    },
    emits: ["refreshList"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faCopy, faDownload, faLink, faShareAlt, faTrashRestore);
        const userStore = useUserStore();
        const { confirm } = useConfirmDialog();
        const { isAnonymous } = storeToRefs(useUserStore());
        const downloadUrl = computed(() => {
            return withPrefix(`/api/workflows/${props.workflow.id}/download?format=json-download`);
        });
        const shared = computed(() => {
            if (userStore.currentUser) {
                return userStore.currentUser.username !== props.workflow.owner;
            }
            else {
                return false;
            }
        });
        function onCopy() {
            return __awaiter(this, void 0, void 0, function* () {
                const confirmed = yield confirm("Are you sure you want to make a copy of this workflow?", "Copy workflow");
                if (confirmed) {
                    yield copyWorkflow(props.workflow.id, props.workflow.owner);
                    emit("refreshList", true);
                    Toast.success("Workflow copied");
                }
            });
        }
        function onRestore() {
            return __awaiter(this, void 0, void 0, function* () {
                const confirmed = yield confirm("Are you sure you want to restore this workflow?", "Restore workflow");
                if (confirmed) {
                    yield undeleteWorkflow(props.workflow.id);
                    emit("refreshList", true);
                    Toast.info("Workflow restored");
                }
            });
        }
        const relativeLink = computed(() => {
            return `/published/workflow?id=${props.workflow.id}`;
        });
        const fullLink = computed(() => {
            return getFullAppUrl(relativeLink.value.substring(1));
        });
        function onCopyPublicLink() {
            copy(fullLink.value);
            Toast.success("Link to workflow copied");
        }
        return { __sfc: true, props, emit, userStore, confirm, isAnonymous, downloadUrl, shared, onCopy, onRestore, relativeLink, fullLink, onCopyPublicLink, faCopy, faDownload, faLink, faShareAlt, faTrashRestore, FontAwesomeIcon, BButton };
    }
});
